import React, { useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { InView } from "react-intersection-observer";
import {
  SectionTypes,
  CONTEXT_MENU_ACTIONS,
} from "components/TemplateEditor/Constants";
import { ContextMenu } from "../ContextMenu";

type Position = { x: number; y: number };
type PageWrapperProps = {
  id: number;
  pageProperties: any;
  children: JSX.Element | JSX.Element[];
  onChangeView: (id: number) => void;
  onClick: (id: number) => void;
  onDrop: (
    item: any,
    dropPosition: Position,
    actionType?: CONTEXT_MENU_ACTIONS
  ) => void;
};

const PageWrapper: React.FC<PageWrapperProps> = (props) => {
  const { id, children, pageProperties, onChangeView, onClick, onDrop } = props;
  const { height, width } = pageProperties;

  const [pasteEventData, setPasteEventData] = useState<{
    target: any;
    position: Position;
  }>({
    target: null,
    position: {
      x: 0,
      y: 0,
    },
  });

  const ref = useRef<any>();

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [SectionTypes.USC_SECTION, SectionTypes.USC_TABLE],
    drop: (item, monitor) => {
      const offset = monitor.getSourceClientOffset();
      if (offset && ref.current) {
        const dropTargetXy = ref.current.getBoundingClientRect();
        const x = offset.x - dropTargetXy.left;
        const y = offset.y - dropTargetXy.top;
        const dropPosition = {
          x: x > 0 ? x : 0,
          y: y > 0 ? y : 0,
        };
        onDrop(item, dropPosition);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  drop(ref);

  const isActive = isOver && canDrop;
  let backgroundColor = "#ffffff";
  if (isActive) {
    backgroundColor = "#53c41a18";
  } else if (canDrop) {
    backgroundColor = "#53c41a18";
  }

  return (
    <InView
      as="div"
      key={id}
      onChange={(inView) => {
        onChangeView && inView && onChangeView(id);
      }}
      onContextMenu={(event) => {
        event.preventDefault();
        setPasteEventData({
          target: event.target,
          position: {
            x: event.nativeEvent.offsetX,
            y: event.nativeEvent.offsetY,
          },
        });
      }}
    >
      <ContextMenu
        pasteEventData={pasteEventData}
        onPaste={(item: any, actionType?: CONTEXT_MENU_ACTIONS) =>
          onDrop(item, pasteEventData.position, actionType)
        }
        onRemoveSection={() => onClick(id)}
      >
        <div
          className="editor-page"
          id={`page_${id}`}
          ref={ref}
          key={id}
          style={{
            width,
            height,
            backgroundColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(event) => {
            event.preventDefault();
            onClick(id);
          }}
        >
          {children}
        </div>
      </ContextMenu>
    </InView>
  );
};

export default PageWrapper;
